export default "__VITE_ASSET__C7$N_34A__"